import { render, staticRenderFns } from "./ManagerCampHousesRegistryScrollFixTable.vue?vue&type=template&id=436f82f8&lang=pug&"
import script from "./ManagerCampHousesRegistryScrollFixTable.vue?vue&type=script&lang=js&"
export * from "./ManagerCampHousesRegistryScrollFixTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports